import React from 'react';
import clsx from 'clsx';
import {UseFormReturn} from 'react-hook-form';
import {
	composeClasses,
	styled,
	type WithClasses,
} from '@netx/core-components/Theme';
import {CustomFormItem} from '../CustomFormItem/CustomFormItem';
import {
	customFormClasses,
	getCustomFormUtilityClass,
	CUSTOM_FORM_CLASS_NAME,
	type CustomFormClasses,
	type CustomFormClassKey,
} from './customFormClasses';
import type {ICustomFormItem, CustomFormFormValues} from '../../types';

type CustomFormOwnerState = WithClasses<CustomFormClasses, {}>;

const useUtilityClasses = (props: CustomFormOwnerState) => {
	const {classes} = props;
	const slots = {
		root: ['root'],
	} as const;
	return composeClasses<CustomFormClassKey>(
		slots,
		getCustomFormUtilityClass,
		classes,
	);
};

export const CustomFormRoot = styled('div', {
	name: CUSTOM_FORM_CLASS_NAME,
	slot: 'Root',
})(({theme}) => ({
	width: '100%',
}));

export type CustomFormProps<
	TValues extends CustomFormFormValues = CustomFormFormValues,
> = WithClasses<
	CustomFormClasses,
	{
		disabled?: boolean;
		form: UseFormReturn<TValues>;
		items: ICustomFormItem[];
	}
>;

export const CustomFormPrimitive = <
	TValues extends CustomFormFormValues = CustomFormFormValues,
>({
	classes: _classes,
	className,
	disabled,
	form,
	items,
}: CustomFormProps<TValues>) => {
	const ownerState: CustomFormOwnerState = {
		classes: _classes,
		className,
	};

	const classes = useUtilityClasses(ownerState);

	return (
		<CustomFormRoot className={clsx(classes.root, className)}>
			{items.map((item) => (
				<CustomFormItem<TValues>
					key={item.label.key}
					disabled={disabled}
					form={form}
					item={item}
				/>
			))}
		</CustomFormRoot>
	);
};

export const CustomForm = CustomFormPrimitive;

export default CustomForm;
